import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { Provider } from 'react-redux';
import './index.css';
import store from './Redux/store';
import { ApolloProvider } from '@apollo/client';
import apolloClient from './apollo/config';
import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY);

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://dc118a6f5dd2beb161244223ce523793@o4510562038906880.ingest.us.sentry.io/4510931967213568'
  });
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </Provider>
);
